import { type ICianApiSiteV1GetUserDataByRequestResponse } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

type GetAnalyticsUserParams = {
  user: ICianApiSiteV1GetUserDataByRequestResponse['data']['user'] | null;
};

export type AnalyticsUser = { userId: number } | {};

export function getAnalyticsUser(params: GetAnalyticsUserParams): AnalyticsUser {
  const { user } = params;

  if (user?.isAuthenticated) {
    /**
     * @description Тут очень корявый контракт с беком, если пользователь авторизован, то у него не может не быть этих
     *   полей, так что приходится приводить типы
     */
    return {
      userId: user.userId as number,
    };
  }

  return {};
}
